import React from 'react';
import logo from '../../assest/logo.svg';
import '../../csscomponent/LogoButtonLoader.css';

export default function LogoButtonLoader({ text = 'Loading...', isDarkText = false }) {
  return (
    <span className={`btn-logo-loader ${isDarkText ? 'btn-logo-loader-dark' : ''}`}>
      <img src={logo} alt="Loading" className="btn-logo-loader-mark" />
      <span className="btn-logo-loader-text">{text}</span>
    </span>
  );
}
